import {
  BadgeGreen,
  BadgeWhiteFill,
  BadgeGrey,
  BadgeRed,
} from "../../../../../components/badge/Badge";

export const StatusBadge = ({
  status,
}: {
  status:
    | "optimistic"
    | "draft"
    | "paid"
    | "failed"
    | "issued"
    | "processing"
    | string;
}) => {
  switch (status) {
    case "draft":
      return (
        <BadgeWhiteFill className="text-sm font-medium">Draft</BadgeWhiteFill>
      );
    case "processing":
      return <BadgeGrey className="text-sm font-medium">Processing</BadgeGrey>;
    case "paid":
      return <BadgeGreen className="text-sm font-medium">Paid</BadgeGreen>;
    case "failed":
      return <BadgeRed className="text-sm font-medium">Failed</BadgeRed>;
    default:
      return status;
  }
};
